import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import BillingCallback from './components/BillingCallback';
import AdminSettlements from './components/AdminSettlements';
import MyPage from './components/MyPage';
import AboutPage from './components/AboutPage';
import CreatorsPage from './components/CreatorsPage';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { initAnalytics } from './analytics';

initAnalytics();

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  render() {
    if (this.state.error) {
      return <pre style={{ padding: 20, color: 'red', whiteSpace: 'pre-wrap' }}>{String(this.state.error)}</pre>;
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/billing/success" element={<BillingCallback type="success" />} />
          <Route path="/billing/fail" element={<BillingCallback type="fail" />} />
          <Route path="/admin/settlements" element={<AdminSettlements />} />
          <Route path="/mypage" element={<MyPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/creators" element={<CreatorsPage />} />
          <Route path="/:slug/:recipeSlug" element={<App />} />
          <Route path="/:slug" element={<App />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
